import { Flags } from "components/Flags";

const FlagsAdapter = () => <Flags />

export default FlagsAdapter;
